import request from "@/utils/request";

/**
 * 列表
 * @param data
 * @returns {AxiosPromise}
 */
export const updxydmList = (data) =>  request({
  method: 'post',
  url: `/yzdservice/enterprise/nbry/updxydm/list`,
  data: data
})

/**
 * 新增
 * @param data
 * @returns {AxiosPromise}
 */
export const addSave = (data) =>  request({
  method: 'post',
  url: `/yzdservice/enterprise/nbry/updxydm/addSave`,
  data: data
})
